<template>
    <div class="flex flex-col items-center justify-center h-full">
        <font-awesome-icon :icon="['far', 'envelope']" class="text-48px mr-2 text-gray-300" />
        <p class="pt-3 px-4 text-center text-gray-600">Select a contact or group to view or send a message</p>
    </div>

</template>


<script>

export default {
    name: 'InboxBlankPlaceholder',
};

</script>

<style scoped>
div {
    min-height: 605px;
}
</style>